module.exports = __webpack_public_path__ + "img/IMG_1605.6c9db914.jpeg";